module.exports = __webpack_public_path__ + "static/img/2.ba4b7f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/aboutPage/2.png
// module id = FatK
// module chunks = 14